import { Component, OnInit } from '@angular/core';
import {LoginService} from '../login.service';
import {GlobalDataService} from '../global-data.service';
import {Router} from '@angular/router';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  private username = '';
  private password = '';
  private loginError: string;

  constructor(private loginService: LoginService, private globalDataService: GlobalDataService, private router: Router) {

  }

  ngOnInit() {
    this.globalDataService.DeleteCookies();
  }

  onSubmit() {
    this.loginError = null;
    if (this.username !== '' && this.password !== '') {
      this.loginService.login(this.username, this.password)
        .then(this.updateSession.bind(this))
        .catch(this.handleLoginError.bind(this));
    } else {
      this.loginError = 'Username and Password are required.';
    }
  }

  handleLoginError(e) {
    const jsonError = JSON.parse(e._body);
    if (!isNullOrUndefined(jsonError.sub_status)) {
      this.loginError = jsonError.message;
    } else {
      this.loginError = 'The server encountered an error.  If the problem persists, contact your system admin.';
    }
  }

  updateSession(result) {
    this.globalDataService.loginType = 'clsw';
    this.globalDataService.token = result.token;
    this.globalDataService.role = result.role;
    this.router.navigate(['/create/order']);
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts